export const dayNewLeave = (t) => {return  [
    {
        name: 1,
        value: "first"
    },
    {
        name: 2,
        value: "second"
    },
    {
        name: 3,
        value: "third"
    },
    {
        name: 4,
        value: "fourth"
    },
    {
        name: 5,
        value: "fifth"
    },
    {
        name: 6,
        value: "sixth"
    },
    {
        name: 7,
        value: "seventh"
    },
    {
        name: 8,
        value: "eighth"
    },
    {
        name: 9,
        value: "nineth"
    },
    {
        name: 10,
        value: "tenth"
    },
    {
        name: 11,
        value: "eleventh"
    },
    {
        name: 12,
        value: "twelveth"
    },
    {
        name: 13,
        value: "thirteenth"
    },
    {
        name: 14,
        value: "fourteenth"
    },
    {
        name: 15,
        value: "fifteenth"
    },
    {
        name: 16,
        value: "sixteenth"
    },
    {
        name: 17,
        value: "seventeenth"
    },
    {
        name: 18,
        value: "eighteenth"
    },{
        name: 19,
        value: "nineteenth"
    },{
        name: 20,
        value: "twentyth"
    },{
        name: 21,
        value: "twenty first"
    },
    {
        name: 22,
        value: "twenty second"
    },
    {
        name: 23,
        value: "twenty third"
    },
    {
        name: 24,
        value: "twenty fourth"
    },
    {
        name: 25,
        value: "twenty fifth"
    },
    {
        name: 26,
        value: "twenty sixth"
    },
    {
        name: 27,
        value: "twenty seventh"
    },
    {
        name: 28,
        value: "twenty eighth"
    },
    {
        name: 29,
        value: "twenty nineth"
    },
    {
        name: 30,
        value: "thirtyth"
    },
    {
        name: 31,
        value: "thirty first"
    },
    {
        name: t("tnp.setting.startOfMonth"),
        value: "start of month"
    },
    {
        name: t("tnp.setting.endOfMonth"),
        value: "end of month"
    },
    {
        name: t("tnp.setting.enough"),
        value: "enough"
    },
]}